var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { MenuItem } from "@mui/material";
import { TextField } from "./TextField";
export const Selector = (_a) => {
    var { fullWidth = true, options } = _a, props = __rest(_a, ["fullWidth", "options"]);
    return (React.createElement(TextField, Object.assign({}, props, { select: true, fullWidth: fullWidth }), options.map((o, i) => (React.createElement(MenuItem, { key: 'select-item-' + o.value + '-' + i, value: o.value }, o.label)))));
};
//# sourceMappingURL=Selector.js.map